// extracted by mini-css-extract-plugin
export default {"lista":"ListagemSkins_lista__6xsPh"};